"use client";

import React from "react";
import { ArrowRight, Mail, TrendingUp } from "lucide-react";

/**
 * BrokerProgram — Section 7: Final Apply-CTA
 * Drop-in für: src/pages/BrokerProgram/sections/KontaktHinweis.tsx
 *
 * Dunkler CTA-Block (B2B-Tonality), Mail-Action zur Anmeldung.
 */

export default function KontaktHinweis() {
  return <section className="relative w-full bg-foreground text-background py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-foreground to-gray-900 z-0" />

      <div className="relative z-10 container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-3 py-1 text-xs font-medium text-white">
            <TrendingUp className="w-3 h-3" />
            30 % Provision · 12 Monate · Kostenlos
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-background drop-shadow-md leading-tight">
            Bereit, mit uns zu verdienen?
          </h2>
          <p className="text-lg md:text-xl text-background/80 max-w-2xl mx-auto font-medium leading-relaxed">
            Schreiben Sie uns eine Mail mit einer kurzen Vorstellung. Wir
            aktivieren Ihren Vermittler-Account innerhalb von 24 Stunden.
          </p>
          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="mailto:info@pagemaker24.ch?subject=Vermittlerprogramm%20Anmeldung&body=Hallo%20PAGEMAKER24-Team%2C%0A%0Aich%20möchte%20mich%20als%20Vermittler%20anmelden.%0A%0AKurz%20zu%20mir%3A%0A-%20Name%2FFirma%3A%20%0A-%20T%C3%A4tigkeit%3A%20%0A-%20Mein%20typischer%20Kundenkreis%3A%20%0A%0AIch%20freue%20mich%20auf%20Ihre%20R%C3%BCckmeldung.%0A%0AFreundliche%20Gr%C3%BCsse" className="group inline-flex items-center justify-center gap-2 bg-primary text-white rounded-full px-10 py-4 text-base md:text-lg font-bold shadow-2xl shadow-primary/30 transition-all duration-300 hover:scale-105">
              <Mail className="w-5 h-5" />
              Vermittler werden
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <p className="text-sm text-background/60">
              Antwort innerhalb 24 Stunden
            </p>
          </div>
        </div>
      </div>
    </section>;
}